<script>
import ListKompetensiProfesi from "./list-kompetensi-profesi.vue";

export default {
  components: {
    ListKompetensiProfesi,
  },
};
</script>
<template>
  <ListKompetensiProfesi />
</template>
